import UAParser from 'ua-parser-js';
import { get } from 'lodash';
import queryString from "query-string";
import { ENTER, SPACE } from '../../constants/keyboardCodes';
import { QUIT_SEB_URL } from '../../constants/url';

const IS_KIOSK_MODE_AVAILABLE = 'is-kiosk-mode-available';

export const isSafari = () => {
    const parser = new UAParser();
    const browserName = get(parser.getBrowser(), 'name', '');
    return browserName === 'Safari';
};

export const isMacOSSafari13 = () => {
    const parser = new UAParser();
    const osName = get(parser.getOS(), 'name', '');
    const browserName = get(parser.getBrowser(), 'name', '');
    const browserMajorVersion = parseInt(get(parser.getBrowser(), 'major', ''), 10);
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) \
    // AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0 Safari/605.1.15"
    return osName === 'Mac OS' && browserName === 'Safari' && browserMajorVersion >= 13;
};

export const isIOS = () =>
    // Copied from here: http://stackoverflow.com/questions/9038625/detect-if-device-is-ios
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// i - type of release (major, minor)
const compareVersions = (version, otherVersion, i = 0) => {
    const rec = version[i];
    const act = otherVersion[i] ? otherVersion[i] : 0;

    if (rec === act) {
        return version[i + 1] ? compareVersions(version, otherVersion, i + 1) : true;
    } if (rec > act) {
        return true;
    } if (act > rec) {
        return false;
    }
    return false;
};

export const isOSVersionEqualOrGreaterThan = (version) => {
    const versionStr = (/OS ([0-9_]*)/gi).exec(navigator.appVersion)[1];
    const versionArr = versionStr.split('_').map(Number);
    return compareVersions(versionArr, version);
};

export const isIOS13 = () =>
    // Taken from here: https://stackoverflow.com/a/58064481
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream;

export const isIOS15Safari = (deviceOnly = true) => {
    const { os, browser } = new UAParser().setUA(global.navigator.userAgent).getResult();
    return os.name === 'Mac OS' && browser.name === 'Safari' && browser.version >= 15 && (!deviceOnly || navigator.maxTouchPoints > 1);
};

export const getURLParam = (URLparam) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(URLparam);
};


export const actionOnKeyboardPress = (e, fn) => {
    if (e.code === ENTER || e.code === SPACE || e.keyCode === ENTER || e.keyCode === SPACE) {
        fn();
    }
};

export const storeKioskModeParameter = () => {
    const queryParameters = queryString.parse(window.location.search);
    // eslint-disable-next-line dot-notation
    const isKioskModeParamsAvailable = queryParameters['e3104518cb454b7280f6ca16ae28f2ef'] === 'ad5b97c6-68ee-40d4-b857-1e2d31a0dd4b';
    if (isKioskModeParamsAvailable) {
        sessionStorage.setItem(IS_KIOSK_MODE_AVAILABLE, isKioskModeParamsAvailable);
    }
};

const getKioskModeParameters = () => sessionStorage.getItem(IS_KIOSK_MODE_AVAILABLE);

export const removeKioskModeParameters = () => {
    if (sessionStorage.getItem(IS_KIOSK_MODE_AVAILABLE)) {
        sessionStorage.removeItem(IS_KIOSK_MODE_AVAILABLE);
    }
};

export const isChromeOS = () => /CrOS/.test(navigator.userAgent);

export const isKioskChromeOS = () => isChromeOS() && getKioskModeParameters();

export const setLouisianaCookie = () => {
    // Make user be able to log in with the Louisiana login page
    // This is hardcode, that would be changed post MVP
    document.cookie = `loginops_id=louisiana; Domain=.amplify.com; Path=/`;
};

export const  handleCloseSEB = () => {
    window.location.assign(QUIT_SEB_URL);
};

export const isAnyUrlMatchesPathname = (pathname, urlsList = []) => urlsList.some(url => pathname === url);
